import { GTMProduct } from '../model';
import { GTMTrackProductDetailImpression } from '../model/TrackingObject';

export type ProductDetailImpressionEvent = {
    event: 'eec_productview';
    ecommerce: {
        currencyCode?: string;
        detail: {
            actionField: {
                list: string;
            };
            products: GTMProduct[];
        };
    };
};

export const trackProductDetailImpressionEvent = ({
    product,
    list,
    currencyCode
}: GTMTrackProductDetailImpression): ProductDetailImpressionEvent => ({
    event: 'eec_productview',
    ecommerce: {
        currencyCode,
        detail: {
            actionField: {
                list,
            },
            products: [{ ...product[0] }],
        },
    },
});
